import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  Film,
  Pause,
  Pencil,
  Play,
  Plus,
  Repeat,
  Send,
  X,
  type LucideIcon,
} from "lucide-react";

type IconProps = {
  size?: number;
  strokeWidth?: number;
  fill?: string;
  className?: string;
};

function makeIcon(Icon: LucideIcon) {
  return function TkticIcon({
    size = 16,
    strokeWidth = 1.75,
    fill = "none",
    className,
  }: IconProps) {
    return (
      <Icon
        size={size}
        strokeWidth={strokeWidth}
        fill={fill}
        className={className}
        aria-hidden="true"
      />
    );
  };
}

export const PlayIcon = makeIcon(Play);
export const PauseIcon = makeIcon(Pause);
export const ChevronLeftIcon = makeIcon(ChevronLeft);
export const ChevronRightIcon = makeIcon(ChevronRight);
export const ChevronsLeftIcon = makeIcon(ChevronsLeft);
export const ChevronsRightIcon = makeIcon(ChevronsRight);
export const RepeatIcon = makeIcon(Repeat);
export const FilmIcon = makeIcon(Film);
export const PlusIcon = makeIcon(Plus);
export const SendIcon = makeIcon(Send);
export const CloseIcon = makeIcon(X);
export const PencilIcon = makeIcon(Pencil);
